/* ============================================================
   jeravales · Find Your Crystal — Quiz Engine
   服务端渲染题目（Liquid），本文件只做：翻页交互 + 五行计分 +
   结果渲染 + 购物车属性写入。不注入任何题目内容。
   判定依据：《2026-09-21 测评判定逻辑设计》定稿
   - Q1–Q5 人格题：命中五行 +1
   - 归一化：命中率 = 命中题数 ÷ 该五行出场题数（分母见 DENOM）
   - Q8 生日：+0.35；Q9 视觉：+0.50
   - Q9 保底：顾客亲手选的款必进前二
   - 平票：按答题顺序最早选中者优先
   - 主推属性写入购物车：quiz_element / quiz_product
   ============================================================ */
(function () {
  "use strict";

  var root = document.querySelector(".jv-quiz");
  if (!root) return;

  var DATA = JSON.parse(document.getElementById("jv-quiz-data").textContent);

  /* ---------- 状态 ---------- */
  var answers = {};        // questionKey -> optionKey
  var screens = [];
  var current = 0;
  var q9Timer = null;      // 预留计时器句柄（10-04 晚 jera 定：Q9 不再自动翻页，改「点了才出报告」）

  /* ---------- 工具 ---------- */
  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }

  /* ---------- 低语（jera 2026-10-06 定：「缩到两行，但压紧」）
     结论：五款低语 86–177 字符，最长两款桌面一行放不下（实测会缩到 6px 或溢出）。
     ⇒ 放弃一行，交给 CSS 折成两行并压紧行距（见 .jv-whisper）。
     此处不再做字号反推，保留空占位以防日后改回。 ---------- */

  var STEP = { q1: 1, q2: 2, q3: 3, q4: 4, q5: 5, q8: 6, q9: 7 };

  function showScreen(idx) {
    current = idx;
    screens.forEach(function (s, i) { s.classList.toggle("is-active", i === idx); });
    var pct = Math.round((idx / Math.max(screens.length - 2, 1)) * 100);
    $(".jv-progress__bar").style.width = Math.min(pct, 100) + "%";
    var key = screens[idx].getAttribute("data-key");
    var stepEl = $(".jv-progress__step");
    if (stepEl) {
      if (STEP[key]) {
        stepEl.textContent = "Question " + STEP[key] + " of 7";
        stepEl.classList.add("is-visible");
      } else {
        stepEl.classList.remove("is-visible");
      }
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  /* ---------- 计分 ---------- */
  function computeScores() {
    var hits = { wood: 0, fire: 0, earth: 0, metal: 0, water: 0 };
    var firstPick = {};    // element -> 最早被选中的题序
    var order = 0;

    // 1) 人格题 Q1–Q5
    DATA.questions.forEach(function (q) {
      if (!/^q[1-5]$/.test(q.key)) return;
      var picked = answers[q.key];
      if (!picked) return;
      order += 1;
      var el = q.options[picked].element;
      hits[el] += 1;
      if (!(el in firstPick)) firstPick[el] = order;
    });

    // 2) 归一化：命中率
    var scores = {};
    Object.keys(hits).forEach(function (el) {
      scores[el] = hits[el] / DATA.denominators[el];
    });

    // 3) 生日 +0.35
    var month = answers.q8; // 'm1'..'m12'
    if (month) {
      var mel = DATA.monthElements[month.replace("m", "")];
      if (mel) scores[mel] += 0.35;
    }

    // 4) 视觉 +0.50
    var visualEl = answers.q9 ? DATA.bracelets[answers.q9].element : null;
    if (visualEl) scores[visualEl] += 0.50;

    // 5) 排序（命中率→总分；平票按最早选中题序，未选中排最后）
    var ranked = Object.keys(scores).sort(function (a, b) {
      if (scores[b] !== scores[a]) return scores[b] - scores[a];
      var fa = (a in firstPick) ? firstPick[a] : 99;
      var fb = (b in firstPick) ? firstPick[b] : 99;
      return fa - fb;
    });

    var primary = ranked[0];
    var secondary = ranked[1];

    // 6) Q9 保底：顾客亲手选的款必进前二
    if (visualEl && visualEl !== primary && visualEl !== secondary) {
      secondary = visualEl;
    }

    return { scores: scores, hits: hits, ranked: ranked, primary: primary, secondary: secondary, visual: visualEl };
  }

  /* ---------- 购物车属性 ---------- */
  // ⚠️ 2026-09-30 修：result.primary 是「五行名」（water/wood/...），
  //    而 DATA.bracelets 的键是「款名」（depth/harvest/...）。
  //    旧写法 DATA.bracelets[result.primary] 恒为 undefined，
  //    取 .product_handle 直接抛 TypeError —— 而且这句在 try 之外，
  //    把 renderResult 整个打断，结果页永远不显示（页面看上去「没反应」）。
  function braceletHandleFor(element) {
    var keys = Object.keys(DATA.bracelets);
    for (var i = 0; i < keys.length; i++) {
      if (DATA.bracelets[keys[i]].element === element) return DATA.bracelets[keys[i]].product_handle;
    }
    return "";
  }
  function writeCartAttributes(result) {
    try {
      var attrs = {
        attributes: {
          quiz_element: result.primary,
          quiz_product: braceletHandleFor(result.primary)
        }
      };
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify(attrs)
      }).catch(function () {});
    } catch (e) { /* 静默：属性写入失败不阻断结果展示 */ }
  }

  /* ---------- Q9 款式亮相（jera 10-02）：选中升起 → 其余下沉 ---------- */
  // 选中款升到大图位；下方 4 个备选仍可点，改主意即时刷新大图；
  // 10-04 晚 jera 定：不再自动翻页，客人点「See my result →」才出报告。
  function lookStage(element, opt) {
    var stage = document.getElementById("jv-look-stage");
    var row = document.getElementById("jv-look-row");
    var hint = document.getElementById("jv-look-hint");
    if (!stage || !row) return;
    var img = opt.querySelector(".jv-opt__img");
    var B = DATA.bracelets[opt.getAttribute("data-opt")];
    var R = B ? DATA.results[B.element] : null;
    if (img) {
      var hi = document.getElementById("jv-look-hero-img");
      hi.src = img.currentSrc || img.src;
      hi.alt = img.alt || "";
    }
    // 款名一行说全：产品名 + 五行款（例：Citrine Pixiu Bracelet · Earth）
    // 第十五轮（jera 定）：改用 productName，与 Q7 卡片名／店铺详情页标题一致
    document.getElementById("jv-look-hero-name").textContent =
      R ? R.productName + " · " + R.elementName : "";
    stage.hidden = false;
    row.classList.add("is-picked-row");
    if (hint) hint.textContent = "Not quite it? Tap another one to change it — then open your result when you're ready.";
  }

  /* ---------- 结果渲染 ---------- */
  function renderResult(result) {
    var el = result.primary;
    var R = DATA.results[el];

    $(".jv-result__title").textContent = R.echoTitle;
    $(".jv-result__element").innerHTML =
      "Your element is <b>" + R.elementName + "</b>";

    // 散文层（The Five Echoes）
    var echo = $(".jv-echo");
    echo.innerHTML = "";
    R.prose.forEach(function (p) {
      var node = document.createElement("p");
      node.textContent = p;
      echo.appendChild(node);
    });
    $(".jv-whisper").textContent = "Crystal Whisper: " + R.whisper;

    // 均衡提示
    var note = $(".jv-balance-note");
    var top = result.scores[result.ranked[0]];
    var second = result.scores[result.ranked[1]];
    if (top < 0.8 || top - second < 0.05) {
      note.style.display = "block";
      note.textContent =
        "Your five elements sit in a quiet balance — " +
        (result.visual && result.visual !== el
          ? "we honored both your answers and the bracelet your eyes landed on first."
          : "we weighed your answers and your first instinct exactly the same.");
    } else {
      note.style.display = "none";
    }

    // 事实层
    $("#jv-fact-element").textContent = R.elementName;
    $("#jv-fact-stone").textContent = R.primaryStone;
    $("#jv-fact-also").textContent = R.alsoIncludes.join(" · ");
    $("#jv-fact-bracelet").textContent = R.braceletLine;

    // 五行剖面
    var profile = $(".jv-profile");
    profile.innerHTML = "";
    DATA.elementOrder.forEach(function (e) {
      var pctV = Math.round(result.scores[e] * 100);
      var row = document.createElement("div");
      row.className = "jv-profile__row";
      row.innerHTML =
        '<span>' + DATA.elementNames[e] + "</span>" +
        '<span class="jv-profile__track"><span class="jv-profile__fill" data-w="' + pctV +
        '" style="background:' + DATA.elementColors[e] + '"></span></span>' +
        '<span class="jv-profile__num">' + pctV + "%</span>";
      profile.appendChild(row);
    });
    requestAnimationFrame(function () {
      $all(".jv-profile__fill").forEach(function (f) { f.style.width = f.getAttribute("data-w") + "%"; });
    });

    // 主推卡
    $("#jv-pick-img").src = R.lookImage || R.productImage;
    $("#jv-pick-img").alt = R.braceletLine;
    $("#jv-pick-name").textContent = R.productName;
    $("#jv-pick-link").href = "/products/" + R.productHandle;
    // 🔴 jera 2026-10-07 23:5x 定：「末屏底部主按钮换成加购导向」
    //    ⇒ 底部主按钮从「Retake the quiz」改为指向推荐款商品页的按钮，
    //       与卡内 View This Bracelet 同一目的地（同一 productHandle）。
    //       用 getElementById 兜底，元素不存在时不报错。
    var pickCta = document.getElementById("jv-pick-link-cta");
    if (pickCta) {
      pickCta.href = "/products/" + R.productHandle;
      /* 与卡内 View This Bracelet 同一目的地，文案必须分开，否则像两个不同的东西。 */
      var jvShort = String(R.productName || "").replace(/\s*Pixiu.*$/i, "").trim();
      if (jvShort) pickCta.textContent = "Shop the " + jvShort + " →";
    }
    $("#jv-pick-desc").textContent = R.pickDesc;

    // 备选四款（除主推外的其余四款；按测评得分排序）
    // 🔴 jera 2026-10-07 定「删干净」：去掉备选卡上的「· Your eyes chose this」标记
    //    （她把「METAL · YOUR EYES ／ CHOOSE THIS」被卡宽挤断的第二行看成了「多出来的一行字」）。
    //    同时不再给该卡加 jv-alt--eyes（淡玫瑰描边）⇒ 四张备选卡完全一致。
    var altsGrid = $("#jv-alts-grid");
    if (altsGrid) {
      altsGrid.innerHTML = "";
      var altOrder = result.ranked.filter(function (e) { return e !== el; });
      DATA.elementOrder.forEach(function (e) {
        if (e !== el && altOrder.indexOf(e) === -1) altOrder.push(e);
      });
      altOrder.forEach(function (e) {
        var A = DATA.results[e];
        if (!A) return;
        var card = document.createElement("div");
        card.className = "jv-alt";
        card.innerHTML =
          '<img class="jv-alt__img" src="' + (A.lookImage || A.productImage) + '" alt="' + A.braceletLine + '" loading="lazy">' +
          '<div class="jv-alt__body">' +
            '<p class="jv-alt__tag"><span class="jv-alt__dot" style="background:' + DATA.elementColors[e] + '"></span>' +
              A.elementName + '</p>' +
            /* jera 2026-10-06 定：「4 个按钮放到手串名称的旁边」
               ⇒ 名称与 View 按钮同行：左名称、右按钮。 */
            '<div class="jv-alt__namerow">' +
              '<h3 class="jv-alt__name">' + A.productName + '</h3>' +
              '<a class="jv-btn jv-btn--ghost jv-btn--small jv-alt__view" href="/products/' + A.productHandle + '">View</a>' +
            '</div>' +
            '<p class="jv-alt__desc">' + A.pickDesc + '</p>' +
          '</div>';
        altsGrid.appendChild(card);
      });
    }

    // 结果出现后写入购物车属性
    writeCartAttributes(result);

    // 切屏
    screens.forEach(function (s) { s.classList.remove("is-active"); });
    $(".jv-progress__bar").style.width = "100%";
    var stepEl2 = $(".jv-progress__step");
    if (stepEl2) stepEl2.classList.remove("is-visible");
    root.classList.add("is-done"); // 展开服务端渲染的「五回响」区
    var res = $(".jv-result");
    res.classList.add("is-active");
    // 结果出现时回到第一屏（三屏制的屏首）
    var rp = $all(".jv-rpane");
    if (rp.length) { rp.forEach(function (p, i) { p.classList.toggle("is-active", i === 0); }); }
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  /* ---------- 事件绑定 ---------- */
  function bindOptions(screenIdx) {
    var screen = screens[screenIdx];
    var key = screen.getAttribute("data-key");
    $all(".jv-opt", screen).forEach(function (opt) {
      opt.addEventListener("click", function () {
        $all(".jv-opt", screen).forEach(function (o) { o.classList.remove("is-picked"); });
        opt.classList.add("is-picked");
        answers[key] = opt.getAttribute("data-opt");

        // Q9 款式屏：先升起选中的那款，让客人看清；改主意可再点别的重选。
        if (key === "q9") {
          lookStage(answers[key], opt);
          return;                              // 不自动翻页：等客人点「See my result →」
        }

        // 其余题：选中后轻微停顿即翻页
        setTimeout(function () {
          if (screenIdx + 1 < screens.length) {
            showScreen(screenIdx + 1);
          } else {
            renderResult(computeScores());
          }
        }, 280);
      });
    });
  }

  /* ---------- 初始化 ---------- */
  screens = $all(".jv-screen");
  screens.forEach(function (screen, i) {
    var key = screen.getAttribute("data-key");
    if (key) bindOptions(i);

    var back = $(".jv-back", screen);
    if (back) back.addEventListener("click", function () { showScreen(Math.max(i - 1, 0)); });

    var start = $(".jv-start", screen);
    if (start) start.addEventListener("click", function () { showScreen(i + 1); });
  });

  // Q9「See my result」：愿意等的人不走这条路；等不及的人一键进结果页
  var q9go = document.getElementById("jv-look-go");
  if (q9go) {
    q9go.addEventListener("click", function () {
      if (!answers.q9) return;                 // 还没选款不响应
      if (q9Timer) { clearTimeout(q9Timer); q9Timer = null; }
      renderResult(computeScores());
    });
  }

  // 结果页「← Back」：回第 9 题选款屏，保留已选，可改选后重新出报告
  var resBack = document.getElementById("jv-result-back");
  if (resBack) {
    resBack.addEventListener("click", function () {
      if (q9Timer) { clearTimeout(q9Timer); q9Timer = null; }
      $(".jv-result").classList.remove("is-active");
      root.classList.remove("is-done");
      showScreen(screens.length - 1);
    });
  }

  /* ---------- 结果页四屏切换（jera 2026-10-06 定：一屏一屏，别再往下翻）
       顺序＝R1 留邮箱 → R2 你的回响 → r4 五回响＋尺寸表 → r3 你的手串＋其他四款
             🔴 jera 2026-10-07 23:4x 定：五回响屏前移到报告之后，产品屏改作末屏。
             切屏按 data-rpane 定位（rPaneIndexOf），与 DOM 顺序无关。 ---------- */
  var rPanes = $all(".jv-rpane");
  function showRPane(idx) {
    if (!rPanes.length) return;
    if (idx < 0) idx = 0;
    if (idx >= rPanes.length) idx = rPanes.length - 1;
    rPanes.forEach(function (p, i) { p.classList.toggle("is-active", i === idx); });
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
  function rPaneIndexOf(name) {
    for (var i = 0; i < rPanes.length; i++) {
      if (rPanes[i].getAttribute("data-rpane") === name) return i;
    }
    return 0;
  }
  if (rPanes.length) {
    var toR2 = document.getElementById("jv-to-r2");
    if (toR2) toR2.addEventListener("click", function () { showRPane(rPaneIndexOf("r2")); });
    var toR3 = document.getElementById("jv-to-r3");
    if (toR3) toR3.addEventListener("click", function () { showRPane(rPaneIndexOf("r3")); });
    var toR4 = document.getElementById("jv-to-r4");
    if (toR4) toR4.addEventListener("click", function () { showRPane(rPaneIndexOf("r4")); });
    // 第一屏（留邮箱）的「跳过」：不留也能看报告
    var giftSkip = document.getElementById("jv-gift-skip");
    if (giftSkip) {
      var skipBtn = giftSkip.querySelector("button");
      if (skipBtn) skipBtn.addEventListener("click", function () { showRPane(rPaneIndexOf("r2")); });
    }
    $all("[data-goto]").forEach(function (b) {
      b.addEventListener("click", function () {
        showRPane(rPaneIndexOf(b.getAttribute("data-goto")));
      });
    });
  }

  var again = $(".jv-result__again button");
  if (again) {
    again.addEventListener("click", function () {
      answers = {};
      if (q9Timer) { clearTimeout(q9Timer); q9Timer = null; }
      $all(".jv-opt").forEach(function (o) { o.classList.remove("is-picked"); });
      var row = document.getElementById("jv-look-row");
      if (row) row.classList.remove("is-picked-row");
      var stage = document.getElementById("jv-look-stage");
      if (stage) stage.hidden = true;
      var hint = document.getElementById("jv-look-hint");
      if (hint) hint.textContent = "Tap the one that catches your eye first.";
      $(".jv-result").classList.remove("is-active");
      root.classList.remove("is-done");
      showScreen(0);
    });
  }

  /* ---------- $15 迎宾礼：留邮箱解锁（jera 2026-10-03 定） ---------- */
  var gift = $("#jv-gift");
  if (gift) {
    var giftGate = $("#jv-gift-gate");
    var giftUnlocked = $("#jv-gift-unlocked");
    var giftForm = $("#jv-gift-form");
    var giftEmail = $("#jv-gift-email");
    var giftSubmit = $("#jv-gift-submit");
    var giftErr = $("#jv-gift-err");
    var giftCodeEl = $("#jv-gift-code");
    /* 🔴 2026-10-07 修正（jera 实测：「我还没有输入邮箱，礼券码就是显示状态」）：
       原来把「已解锁」写进 localStorage，下次进页面直接把券码亮出来 ——
       等于没留邮箱也能白拿券，这一屏「留邮箱」的意义就没了。
       ⇒ 去掉「记住已解锁」：每次进页面一律全新（不预填邮箱、不显示券码），
          只有**本次真的提交过邮箱**，券码才出现。
          （顺手清掉历史遗留的旧标记，免得日后排查被这两把僵尸钥匙误导。） */
    try {
      localStorage.removeItem("jv_gift_unlocked");
      localStorage.removeItem("jv_gift_email");
    } catch (e) {}

    var jvSubmitted = false;   /* 本次会话是否真的提交过邮箱 —— 券码的唯一开关 */

    var jvReveal = function () {
      if (giftCodeEl) giftCodeEl.textContent = gift.getAttribute("data-code") || "";
      /* jera 2026-10-07 定：「礼券码显示的时候，邮箱的框还要在，填的邮箱和礼券码两个框同时在」
         ⇒ 不再把 .jv-gift__gate 整块收掉，改为给卡片加 is-unlocked 类，
            由 CSS 收掉「说明句 / 按钮 / 隐私行」，只留邮箱框（值原样保留），
            券码框紧接其后出现 —— 邮箱框与券码框同屏可见。 */
      gift.classList.add("is-unlocked");
      if (giftUnlocked) giftUnlocked.hidden = false;
    };

    if (giftForm) {
      giftForm.addEventListener("submit", function (e) {
        e.preventDefault();
        var em = (giftEmail && giftEmail.value ? giftEmail.value : "").trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em)) {
          if (giftErr) giftErr.hidden = false;
          if (giftEmail) giftEmail.focus();
          return;
        }
        if (giftErr) giftErr.hidden = true;
        if (giftSubmit) { giftSubmit.disabled = true; giftSubmit.textContent = "Unlocking…"; }
        /* 🔴 2026-10-07 二次修复（jera 实测：「要按三次按钮礼券码才出来」）：
           给券这一步原来依赖异步回报（隐藏 iframe 的 load 事件 / 4 秒兜底定时器），
           而本站表单挂了 Shopify 的隐形人形验证 —— 回报时机不可控，headless 下甚至不回报，
           于是顾客点一次没反应、只能反复点。
           既定原则是「顾客交出邮箱 ＝ 门槛达成，不拿验证环节的风险去卡顾客」
           ⇒ 邮箱一校验通过就**同步**给券，一步到位、绝不依赖任何异步回报。
           form.submit() 照常调用，让邮箱在后台尽量交出去；成不成功都不影响给券
           （form.submit() 按规范不再触发 submit 事件，不会递归；target 已在下方设好）。 */
        jvSubmitted = true;
        jvReveal();
        try { giftForm.submit(); } catch (e) {}
      });
      giftForm.setAttribute("target", "jv_gift_sink");
    }

    var jvSink = document.getElementById("jv-gift-sink");
    if (jvSink) {
      var jvSinkSeen = false;
      jvSink.addEventListener("load", function () {
        if (!jvSinkSeen) { jvSinkSeen = true; return; }
        /* 只有**本次真的提交过邮箱**才给券 —— 否则空 iframe 的杂散 load
           会把券码凭空放出来（jera 实测过「没填邮箱券码就显示」）。
           顾客已交出邮箱 = 门槛达成，券照给，不拿验证环节的风险去卡顾客。 */
        if (!jvSubmitted) return;
        jvReveal();
      });
    }
  }

  /* ---------- $15 迎宾礼：复制券号 ---------- */
  var giftCopy = $("#jv-gift-copy");
  if (giftCopy) {
    giftCopy.addEventListener("click", function () {
      var code = giftCopy.getAttribute("data-code") || "";
      var done = function () {
        giftCopy.textContent = "Copied";
        setTimeout(function () { giftCopy.textContent = "Copy code"; }, 1800);
      };
      /* 复制失败就明说，并把券码选中让人能直接按 Ctrl+C —— 不许静默假装成功。 */
      var fail = function () {
        var span = document.getElementById("jv-gift-code");
        if (span && window.getSelection) {
          try {
            var r = document.createRange();
            r.selectNodeContents(span);
            var s = window.getSelection();
            s.removeAllRanges();
            s.addRange(r);
          } catch (e) {}
        }
        giftCopy.textContent = "Press Ctrl+C";
        setTimeout(function () { giftCopy.textContent = "Copy code"; }, 2600);
      };
      var legacy = function () {
        var ta = document.createElement("textarea");
        ta.value = code;
        ta.setAttribute("readonly", "");
        ta.style.cssText = "position:absolute;left:-9999px";
        document.body.appendChild(ta);
        ta.select();
        var ok = false;
        try { ok = document.execCommand("copy"); } catch (e) {}
        document.body.removeChild(ta);
        if (ok) { done(); } else { fail(); }
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, legacy);
      } else {
        legacy();
      }
    });
  }

  showScreen(0);
})();
